(ns net.kestec.mhda-pilgrimage.db
  (:require-macros
    [net.kestec.mhda-pilgrimage.config :as config])
  (:require
    [day8.re-frame.http-fx]
    [net.kestec.mhda-pilgrimage.public.news.news-events :as news-events]
    [net.kestec.mhda-pilgrimage.public.applications.applications-events :as applications-events]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as application-events]
    [net.kestec.mhda-pilgrimage.auth.auth-events :as auth-events]
    [re-frame.core :as rf]))

;; # Helpers / Init

(def init-db
  {::config 1                                               ;(config/client-config)
   })

(defn has-session? []
  (or
    (not @(rf/subscribe [::get ::me :pilgrimage-id]))       ;; "me call has not happened"
    @(rf/subscribe [::get ::me :is-valid])                  ;; session is valid
    ))

(rf/reg-event-fx
  ::init
  (fn [{db :db} [_ extra]]
    (println "INIT CALLED")
    {:db       (merge db init-db extra)
     :dispatch [::auth-events/load-me]}))

(rf/reg-event-fx
  ::load-all
  (fn [_ _]
    {:dispatch-n [[::news-events/load-news]
                  [::applications-events/load-applications]
                  ]}))

(rf/reg-sub
  ::get
  (fn [db [_ & ks]]
    (get-in db ks)))

(rf/reg-event-db
  ::set!
  (fn [db [_ k v :as args]]
    (when (not= 3 (count args))
      (throw (ex-info "Invalid set call" {:args args})))
    (assoc db k v)))

(rf/reg-event-db
  ::set-in!
  (fn [db [_ path v :as args]]
    (when (not= 3 (count args))
      (throw (ex-info "Invalid set-in call" {:args args})))
    (assoc-in db path v)))

(rf/reg-event-db
  ::update!
  (fn [db [_ path f & args]]
    (apply update-in db path f args)))

(rf/reg-event-fx
  ::log-error
  (fn [_ [_ & msg]]
    {::log-error msg}))

(rf/reg-fx
  ::log-error
  (fn [msg]
    (apply js/console.error msg)))

(rf/reg-event-fx
  ::log-info
  (fn [_ [_ & msg]]
    {::log-info msg}))

(rf/reg-fx
  ::log-info
  (fn [msg]
    (apply js/console.info msg)))

